var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"o-modal"},[_c('div',{staticClass:"o-modal__holder"},[_vm._t("default")],2)]),_c('div',{staticClass:"o-modal__overlay",on:{"click":function($event){return _vm.$emit('onHide')}}})])
}
var staticRenderFns = []

export { render, staticRenderFns }